import type { AgentDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const getAgentChatTitle = (
	agent?: Pick<AgentDetailResponseDTO, "conversationTitle" | "name">,
) => agent?.conversationTitle ?? agent?.name ?? "";
